<template>
  <v-container class="py-0 px-5">
    <v-row>
      <v-col
        cols="12"
        md="6"
      >
        <date-field
          v-model="userOrganization.company_auth"
          field-name="company_auth"
          rules="date"
          autofocus
        />
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <date-field
          v-model="userOrganization.theoretical_examination"
          field-name="theoretical_examination"
          rules="date"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="4"
      >
        <validated-text-field
          v-model="userOrganization.ident"
          field-name="ident"
          rules=""
          type="text"
        />
      </v-col>
      <v-col
        cols="12"
        md="4"
      >
        <validated-text-field
          v-model="userOrganization.mrlsz_id"
          field-name="mrlsz_id"
          rules=""
          type="text"
        />
      </v-col>
      <v-col
        cols="12"
        md="4"
      >
        <validated-text-field
          v-model="userOrganization.fai_id"
          field-name="fai_id"
          rules=""
          type="text"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'EditUserOrganization',
    props: {
      userOrganization: Object,
    },
  }
</script>
